import xhr from 'xhr';

export default async function mainFilter(data) {
  const res = await xhr.post(`/students/filter`, data);
  return res.data;
}
